import React from 'react';

const HUBSPOT_MEETING = 'https://meetings.hubspot.com/jon980';

/**
 * Renders Freddy Leads' Hubspot calendar inline as a direct iframe.
 *
 * Why not the official `<div class="meetings-iframe-container">` + script?
 * That approach depends on Hubspot's embed.js scanning the DOM at script-load
 * time. When the calendar mounts inside a lazy modal (after user click), the
 * scanner has already finished — leaving an empty container. Rendering the
 * iframe directly with `?embed=true` produces the same UI and avoids the
 * timing/race entirely. Tracking + booking still post back to Hubspot.
 */
export default function MeetingEmbed({ className = '', minHeight = 720 }) {
  return (
    <iframe
      src={`${HUBSPOT_MEETING}?embed=true`}
      title="Book a meeting with Jon Fred"
      data-testid="hubspot-meeting-embed"
      className={`w-full border-0 bg-white ${className}`}
      style={{ minHeight, height: minHeight }}
      loading="lazy"
      allow="camera; microphone; clipboard-write"
    />
  );
}
